import ServicesTransactions from './ServicesTransactions.redux';

export default ServicesTransactions;
